import { createSlice, isPending, isRejected, PayloadAction } from '@reduxjs/toolkit';
import { CancelledOrdersGroupBy, DatePresetKey, ICancelledOrdersQuery } from '@/models/cancelledOrders.model';
import { CancelledOrdersState, CANCELLED_ORDERS_SLICE_NAME, initialState } from './models';
import { getCancelledOrdersData, getCancelledPartnersList, getCancelledReasonsList } from './actionCreators';

export const slice = createSlice({
  name: CANCELLED_ORDERS_SLICE_NAME,
  initialState,
  reducers: {
    setCancelledOrdersQuery: (state: CancelledOrdersState, action: PayloadAction<ICancelledOrdersQuery>) => {
      state.query = action.payload;
    },
    setCancelledOrdersPreset: (state: CancelledOrdersState, action: PayloadAction<DatePresetKey>) => {
      state.preset = action.payload;
    },
    setCancelledOrdersGroupBy: (state: CancelledOrdersState, action: PayloadAction<CancelledOrdersGroupBy>) => {
      state.groupBy = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCancelledOrdersData.fulfilled, (state, action) => {
        state.data = action.payload.data;
        state.isLoading = false;
      })
      .addCase(getCancelledReasonsList.fulfilled, (state, action) => {
        state.reasonsList = action.payload.data;
        state.reasonsMeta = action.payload.meta;
        state.isListLoading = false;
      })
      .addCase(getCancelledPartnersList.fulfilled, (state, action) => {
        state.partnersList = action.payload.data;
        state.partnersMeta = action.payload.meta;
        state.isListLoading = false;
      })
      .addMatcher(isPending(getCancelledOrdersData), (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(isPending(getCancelledReasonsList, getCancelledPartnersList), (state) => {
        state.isListLoading = true;
        state.error = null;
      })
      .addMatcher(
        isRejected(getCancelledOrdersData, getCancelledReasonsList, getCancelledPartnersList),
        (state, action) => {
          state.isLoading = false;
          state.isListLoading = false;
          state.error = action.error;
        },
      );
  },
});

export default slice.reducer;

export const { setCancelledOrdersQuery, setCancelledOrdersPreset, setCancelledOrdersGroupBy } = slice.actions;
